import{useRef as r}from"react";import{useIsomorphicLayoutEffect as o}from"./use-isomorphic-layout-effect.js";const t=t=>{const e=r(void 0);return o((()=>{e.current=t})),e.current};export{t as usePreviousValue};
